import { LazyExoticComponent, ReactElement } from "react";

export enum USER_ROLE {
  DASHBOARD,
}

export type TLayoutRoute = {
  layout: React.ComponentType<unknown>;
  routes: TRoute[];
};

type TRoute = {
  name: string;
  path: string;
  roles?: USER_ROLE[];
  component: LazyExoticComponent<() => ReactElement> | (() => ReactElement);
  routes?: TRoute[];
};

export type { TRoute };
